import { CountryCode } from 'libphonenumber-js';

export interface countryCodeDataInterface {
  key: CountryCode;
  code: string;
  name: string;
  currency?: string;
}

export const countryCodeData: { [countryCode: string]: countryCodeDataInterface } = {
  AD: { key: 'AD', code: '+376', name: 'Andorra' },
  AE: { key: 'AE', code: '+971', name: 'United Arab Emirates' },
  AF: { key: 'AF', code: '+93', name: 'Afghanistan' },
  AG: { key: 'AG', code: '+1268', name: 'Antigua and Barbuda' },
  AI: { key: 'AI', code: '+1264', name: 'Anguilla' },
  AL: { key: 'AL', code: '+355', name: 'Albania' },
  AM: { key: 'AM', code: '+374', name: 'Armenia' },
  AO: { key: 'AO', code: '+244', name: 'Angola' },
  AR: { key: 'AR', code: '+54', name: 'Argentina' },
  AS: { key: 'AS', code: '+1684', name: 'American Samoa' },
  AT: { key: 'AT', code: '+43', name: 'Austria' },
  AU: { key: 'AU', code: '+61', name: 'Australia', currency: 'AUD' },
  AW: { key: 'AW', code: '+297', name: 'Aruba' },
  AX: { key: 'AX', code: '+35818', name: 'Aland Islands' },
  AZ: { key: 'AZ', code: '+994', name: 'Azerbaijan' },
  BA: { key: 'BA', code: '+387', name: 'Bosnia and Herzegovina' },
  BB: { key: 'BB', code: '+1246', name: 'Barbados' },
  BD: { key: 'BD', code: '+880', name: 'Bangladesh' },
  BE: { key: 'BE', code: '+32', name: 'Belgium' },
  BF: { key: 'BF', code: '+226', name: 'Burkina Faso' },
  BG: { key: 'BG', code: '+359', name: 'Bulgaria' },
  BH: { key: 'BH', code: '+973', name: 'Bahrain' },
  BI: { key: 'BI', code: '+257', name: 'Burundi' },
  BJ: { key: 'BJ', code: '+229', name: 'Benin' },
  BL: { key: 'BL', code: '+590', name: 'Saint Barthelemy' },
  BM: { key: 'BM', code: '+1441', name: 'Bermuda' },
  BN: { key: 'BN', code: '+673', name: 'Brunei' },
  BO: { key: 'BO', code: '+591', name: 'Bolivia' },
  BQ: { key: 'BQ', code: '+599', name: 'Bonaire, Saint Eustatius and Saba ' },
  BR: { key: 'BR', code: '+55', name: 'Brazil' },
  BS: { key: 'BS', code: '+1242', name: 'Bahamas' },
  BT: { key: 'BT', code: '+975', name: 'Bhutan' },
  BW: { key: 'BW', code: '+267', name: 'Botswana' },
  BY: { key: 'BY', code: '+375', name: 'Belarus' },
  BZ: { key: 'BZ', code: '+501', name: 'Belize' },
  CA: { key: 'CA', code: '+1', name: 'Canada' },
  CC: { key: 'CC', code: '+61', name: 'Cocos Islands' },
  CD: { key: 'CD', code: '+243', name: 'Democratic Republic of the Congo' },
  CF: { key: 'CF', code: '+236', name: 'Central African Republic' },
  CG: { key: 'CG', code: '+242', name: 'Republic of the Congo' },
  CH: { key: 'CH', code: '+41', name: 'Switzerland' },
  CI: { key: 'CI', code: '+225', name: 'Ivory Coast' },
  CK: { key: 'CK', code: '+682', name: 'Cook Islands' },
  CL: { key: 'CL', code: '+56', name: 'Chile' },
  CM: { key: 'CM', code: '+237', name: 'Cameroon' },
  CN: { key: 'CN', code: '+86', name: 'China' },
  CO: { key: 'CO', code: '+57', name: 'Colombia' },
  CR: { key: 'CR', code: '+506', name: 'Costa Rica' },
  CU: { key: 'CU', code: '+53', name: 'Cuba' },
  CV: { key: 'CV', code: '+238', name: 'Cape Verde' },
  CW: { key: 'CW', code: '+599', name: 'Curacao' },
  CX: { key: 'CX', code: '+61', name: 'Christmas Island' },
  CY: { key: 'CY', code: '+357', name: 'Cyprus' },
  CZ: { key: 'CZ', code: '+420', name: 'Czech Republic' },
  DE: { key: 'DE', code: '+49', name: 'Germany' },
  DJ: { key: 'DJ', code: '+253', name: 'Djibouti' },
  DK: { key: 'DK', code: '+45', name: 'Denmark' },
  DM: { key: 'DM', code: '+1767', name: 'Dominica' },
  DO: { key: 'DO', code: '+1809', name: 'Dominican Republic' },
  DZ: { key: 'DZ', code: '+213', name: 'Algeria' },
  EC: { key: 'EC', code: '+593', name: 'Ecuador' },
  EE: { key: 'EE', code: '+372', name: 'Estonia' },
  EG: { key: 'EG', code: '+20', name: 'Egypt' },
  EH: { key: 'EH', code: '+212', name: 'Western Sahara' },
  ER: { key: 'ER', code: '+291', name: 'Eritrea' },
  ES: { key: 'ES', code: '+34', name: 'Spain' },
  ET: { key: 'ET', code: '+251', name: 'Ethiopia' },
  FI: { key: 'FI', code: '+358', name: 'Finland' },
  FJ: { key: 'FJ', code: '+679', name: 'Fiji' },
  FK: { key: 'FK', code: '+500', name: 'Falkland Islands' },
  FM: { key: 'FM', code: '+691', name: 'Micronesia' },
  FO: { key: 'FO', code: '+298', name: 'Faroe Islands' },
  FR: { key: 'FR', code: '+33', name: 'France' },
  GA: { key: 'GA', code: '+241', name: 'Gabon' },
  GB: { key: 'GB', code: '+44', name: 'United Kingdom' },
  GD: { key: 'GD', code: '+1473', name: 'Grenada' },
  GE: { key: 'GE', code: '+995', name: 'Georgia' },
  GF: { key: 'GF', code: '+594', name: 'French Guiana' },
  GG: { key: 'GG', code: '+441481', name: 'Guernsey' },
  GH: { key: 'GH', code: '+233', name: 'Ghana' },
  GI: { key: 'GI', code: '+350', name: 'Gibraltar' },
  GL: { key: 'GL', code: '+299', name: 'Greenland' },
  GM: { key: 'GM', code: '+220', name: 'Gambia' },
  GN: { key: 'GN', code: '+224', name: 'Guinea' },
  GP: { key: 'GP', code: '+590', name: 'Guadeloupe' },
  GQ: { key: 'GQ', code: '+240', name: 'Equatorial Guinea' },
  GR: { key: 'GR', code: '+30', name: 'Greece' },
  GT: { key: 'GT', code: '+502', name: 'Guatemala' },
  GU: { key: 'GU', code: '+1671', name: 'Guam' },
  GW: { key: 'GW', code: '+245', name: 'Guinea-Bissau' },
  GY: { key: 'GY', code: '+592', name: 'Guyana' },
  HK: { key: 'HK', code: '+852', name: 'Hong Kong' },
  HN: { key: 'HN', code: '+504', name: 'Honduras' },
  HR: { key: 'HR', code: '+385', name: 'Croatia' },
  HT: { key: 'HT', code: '+509', name: 'Haiti' },
  HU: { key: 'HU', code: '+36', name: 'Hungary' },
  ID: { key: 'ID', code: '+62', name: 'Indonesia' },
  IE: { key: 'IE', code: '+353', name: 'Ireland' },
  IL: { key: 'IL', code: '+972', name: 'Israel' },
  IM: { key: 'IM', code: '+441624', name: 'Isle of Man' },
  IN: { key: 'IN', code: '+91', name: 'India' },
  IO: { key: 'IO', code: '+246', name: 'British Indian Ocean Territory' },
  IQ: { key: 'IQ', code: '+964', name: 'Iraq' },
  IR: { key: 'IR', code: '+98', name: 'Iran' },
  IS: { key: 'IS', code: '+354', name: 'Iceland' },
  IT: { key: 'IT', code: '+39', name: 'Italy' },
  JE: { key: 'JE', code: '+441534', name: 'Jersey' },
  JM: { key: 'JM', code: '+1876', name: 'Jamaica' },
  JO: { key: 'JO', code: '+962', name: 'Jordan' },
  JP: { key: 'JP', code: '+81', name: 'Japan' },
  KE: { key: 'KE', code: '+254', name: 'Kenya' },
  KG: { key: 'KG', code: '+996', name: 'Kyrgyzstan' },
  KH: { key: 'KH', code: '+855', name: 'Cambodia' },
  KI: { key: 'KI', code: '+686', name: 'Kiribati' },
  KM: { key: 'KM', code: '+269', name: 'Comoros' },
  KN: { key: 'KN', code: '+1869', name: 'Saint Kitts and Nevis' },
  KP: { key: 'KP', code: '+850', name: 'North Korea' },
  KR: { key: 'KR', code: '+82', name: 'South Korea' },
  KW: { key: 'KW', code: '+965', name: 'Kuwait' },
  KY: { key: 'KY', code: '+1345', name: 'Cayman Islands' },
  KZ: { key: 'KZ', code: '+7', name: 'Kazakhstan' },
  LA: { key: 'LA', code: '+856', name: 'Laos' },
  LB: { key: 'LB', code: '+961', name: 'Lebanon' },
  LC: { key: 'LC', code: '+1758', name: 'Saint Lucia' },
  LI: { key: 'LI', code: '+423', name: 'Liechtenstein' },
  LK: { key: 'LK', code: '+94', name: 'Sri Lanka' },
  LR: { key: 'LR', code: '+231', name: 'Liberia' },
  LS: { key: 'LS', code: '+266', name: 'Lesotho' },
  LT: { key: 'LT', code: '+370', name: 'Lithuania' },
  LU: { key: 'LU', code: '+352', name: 'Luxembourg' },
  LV: { key: 'LV', code: '+371', name: 'Latvia' },
  LY: { key: 'LY', code: '+218', name: 'Libya' },
  MA: { key: 'MA', code: '+212', name: 'Morocco' },
  MC: { key: 'MC', code: '+377', name: 'Monaco' },
  MD: { key: 'MD', code: '+373', name: 'Moldova' },
  ME: { key: 'ME', code: '+382', name: 'Montenegro' },
  MF: { key: 'MF', code: '+590', name: 'Saint Martin' },
  MG: { key: 'MG', code: '+261', name: 'Madagascar' },
  MH: { key: 'MH', code: '+692', name: 'Marshall Islands' },
  MK: { key: 'MK', code: '+389', name: 'Macedonia' },
  ML: { key: 'ML', code: '+223', name: 'Mali' },
  MM: { key: 'MM', code: '+95', name: 'Myanmar' },
  MN: { key: 'MN', code: '+976', name: 'Mongolia' },
  MO: { key: 'MO', code: '+853', name: 'Macao' },
  MP: { key: 'MP', code: '+1670', name: 'Northern Mariana Islands' },
  MQ: { key: 'MQ', code: '+596', name: 'Martinique' },
  MR: { key: 'MR', code: '+222', name: 'Mauritania' },
  MS: { key: 'MS', code: '+1664', name: 'Montserrat' },
  MT: { key: 'MT', code: '+356', name: 'Malta' },
  MU: { key: 'MU', code: '+230', name: 'Mauritius' },
  MV: { key: 'MV', code: '+960', name: 'Maldives' },
  MW: { key: 'MW', code: '+265', name: 'Malawi' },
  MX: { key: 'MX', code: '+52', name: 'Mexico' },
  MY: { key: 'MY', code: '+60', name: 'Malaysia' },
  NA: { key: 'NA', code: '+264', name: 'Namibia' },
  NC: { key: 'NC', code: '+687', name: 'New Caledonia' },
  NE: { key: 'NE', code: '+227', name: 'Niger' },
  NF: { key: 'NF', code: '+672', name: 'Norfolk Island' },
  NG: { key: 'NG', code: '+234', name: 'Nigeria' },
  NI: { key: 'NI', code: '+505', name: 'Nicaragua' },
  NL: { key: 'NL', code: '+31', name: 'Netherlands' },
  NO: { key: 'NO', code: '+47', name: 'Norway' },
  NP: { key: 'NP', code: '+977', name: 'Nepal' },
  NR: { key: 'NR', code: '+674', name: 'Nauru' },
  NU: { key: 'NU', code: '+683', name: 'Niue' },
  NZ: { key: 'NZ', code: '+64', name: 'New Zealand', currency: 'NZD' },
  OM: { key: 'OM', code: '+968', name: 'Oman' },
  PA: { key: 'PA', code: '+507', name: 'Panama' },
  PE: { key: 'PE', code: '+51', name: 'Peru' },
  PF: { key: 'PF', code: '+689', name: 'French Polynesia' },
  PG: { key: 'PG', code: '+675', name: 'Papua New Guinea' },
  PH: { key: 'PH', code: '+63', name: 'Philippines' },
  PK: { key: 'PK', code: '+92', name: 'Pakistan' },
  PL: { key: 'PL', code: '+48', name: 'Poland' },
  PM: { key: 'PM', code: '+508', name: 'Saint Pierre and Miquelon' },
  PR: { key: 'PR', code: '+1787 and 1939', name: 'Puerto Rico' },
  PS: { key: 'PS', code: '+970', name: 'Palestinian Territory' },
  PT: { key: 'PT', code: '+351', name: 'Portugal' },
  PW: { key: 'PW', code: '+680', name: 'Palau' },
  PY: { key: 'PY', code: '+595', name: 'Paraguay' },
  QA: { key: 'QA', code: '+974', name: 'Qatar' },
  RE: { key: 'RE', code: '+262', name: 'Reunion' },
  RO: { key: 'RO', code: '+40', name: 'Romania' },
  RS: { key: 'RS', code: '+381', name: 'Serbia' },
  RU: { key: 'RU', code: '+7', name: 'Russia' },
  RW: { key: 'RW', code: '+250', name: 'Rwanda' },
  SA: { key: 'SA', code: '+966', name: 'Saudi Arabia' },
  SB: { key: 'SB', code: '+677', name: 'Solomon Islands' },
  SC: { key: 'SC', code: '+248', name: 'Seychelles' },
  SD: { key: 'SD', code: '+249', name: 'Sudan' },
  SE: { key: 'SE', code: '+46', name: 'Sweden' },
  SG: { key: 'SG', code: '+65', name: 'Singapore' },
  SH: { key: 'SH', code: '+290', name: 'Saint Helena' },
  SI: { key: 'SI', code: '+386', name: 'Slovenia' },
  SJ: { key: 'SJ', code: '+47', name: 'Svalbard and Jan Mayen' },
  SK: { key: 'SK', code: '+421', name: 'Slovakia' },
  SL: { key: 'SL', code: '+232', name: 'Sierra Leone' },
  SM: { key: 'SM', code: '+378', name: 'San Marino' },
  SN: { key: 'SN', code: '+221', name: 'Senegal' },
  SO: { key: 'SO', code: '+252', name: 'Somalia' },
  SR: { key: 'SR', code: '+597', name: 'Suriname' },
  SS: { key: 'SS', code: '+211', name: 'South Sudan' },
  ST: { key: 'ST', code: '+239', name: 'Sao Tome and Principe' },
  SV: { key: 'SV', code: '+503', name: 'El Salvador' },
  SX: { key: 'SX', code: '+599', name: 'Sint Maarten' },
  SY: { key: 'SY', code: '+963', name: 'Syria' },
  SZ: { key: 'SZ', code: '+268', name: 'Swaziland' },
  TC: { key: 'TC', code: '+1649', name: 'Turks and Caicos Islands' },
  TD: { key: 'TD', code: '+235', name: 'Chad' },
  TG: { key: 'TG', code: '+228', name: 'Togo' },
  TH: { key: 'TH', code: '+66', name: 'Thailand' },
  TJ: { key: 'TJ', code: '+992', name: 'Tajikistan' },
  TK: { key: 'TK', code: '+690', name: 'Tokelau' },
  TL: { key: 'TL', code: '+670', name: 'East Timor' },
  TM: { key: 'TM', code: '+993', name: 'Turkmenistan' },
  TN: { key: 'TN', code: '+216', name: 'Tunisia' },
  TO: { key: 'TO', code: '+676', name: 'Tonga' },
  TR: { key: 'TR', code: '+90', name: 'Turkey' },
  TT: { key: 'TT', code: '+1868', name: 'Trinidad and Tobago' },
  TV: { key: 'TV', code: '+688', name: 'Tuvalu' },
  TW: { key: 'TW', code: '+886', name: 'Taiwan' },
  TZ: { key: 'TZ', code: '+255', name: 'Tanzania' },
  UA: { key: 'UA', code: '+380', name: 'Ukraine' },
  UG: { key: 'UG', code: '+256', name: 'Uganda' },
  US: { key: 'US', code: '+1', name: 'United States', currency: 'USD' },
  UY: { key: 'UY', code: '+598', name: 'Uruguay' },
  UZ: { key: 'UZ', code: '+998', name: 'Uzbekistan' },
  VA: { key: 'VA', code: '+379', name: 'Vatican' },
  VC: { key: 'VC', code: '+1784', name: 'Saint Vincent and the Grenadines' },
  VE: { key: 'VE', code: '+58', name: 'Venezuela' },
  VG: { key: 'VG', code: '+1284', name: 'British Virgin Islands' },
  VI: { key: 'VI', code: '+1340', name: 'U.S. Virgin Islands' },
  VN: { key: 'VN', code: '+84', name: 'Vietnam' },
  VU: { key: 'VU', code: '+678', name: 'Vanuatu' },
  WF: { key: 'WF', code: '+681', name: 'Wallis and Futuna' },
  WS: { key: 'WS', code: '+685', name: 'Samoa' },
  YE: { key: 'YE', code: '+967', name: 'Yemen' },
  YT: { key: 'YT', code: '+262', name: 'Mayotte' },
  ZA: { key: 'ZA', code: '+27', name: 'South Africa' },
  ZM: { key: 'ZM', code: '+260', name: 'Zambia' },
  ZW: { key: 'ZW', code: '+263', name: 'Zimbabwe' },
};
